import toast from "react-hot-toast";

const OPTIONS: any = {
  duration: 3000,
  position: "top-right",
  style: {
    zIndex: 999999,
  },
  ariaProps: {
    role: "status",
    "aria-live": "polite",
  },
  removeDelay: 1000,
};

export const SuccessToast = (message: any, removeDelay?: number) => {
  toast.success(message, { ...OPTIONS, removeDelay: removeDelay ?? 1000 });
};

export const ErrorToast = (message: any, removeDelay?: number) => {
  toast.error(message, { ...OPTIONS, removeDelay: removeDelay ?? 1000 });
};
